import React from "react";
import TestimonialBox from "./TestimonialBox";

function TestimonialBoxes() {
  return (
    <>
      <TestimonialBox
        text='"Joining FAT2FIT was the best decision I ever made. Coach Nandha Kumar is incredibly knowledgeable and supportive. In just 3 months I lost 12 kg and feel stronger than ever!"'
        name="Ramesh K."
        job="FAT2FIT Member, Coimbatore"
      />
    </>
  );
}

export default TestimonialBoxes;
